<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.shareDocument}}</h3>
</div>
<div class="modal-body">
    <div class="text-center"><span *ngIf="inprogress"><i class="fa fa-circle-o-notch fa-spin text-grey fa-fw fa-3x"></i></span></div>
    <form class="form" *ngIf="!inprogress">
        <div class="row text-center">
            <div *ngFor='let key of Object.keys(shareLink)' class="col-xs-4 hoverme " style="padding: 15px;">
                <div *ngIf="key!='THUMBNAIL'"><p>{{LOCALIZATION["shareDocument"+key]}}</p>
                    <i class="far fa-clone pointMe fa-lg" (click)="copyToClipboard(shareLink[key])" title="Copy this link to your clipboard."></i>
                    <i class="fas fa-directions pointMe fa-lg" (click)="openLink(shareLink[key])" title="Open this link in a new tab."></i>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button  class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
